import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2'
import { notDeliveredReasonRoutes } from './not-delivered-reason.routing'
import { UpdateNotDeliveredReasonComponent } from './update-not-delivered-reason/update-not-delivered-reason.component'
import { CreateNotDeliveredReasonComponent } from './create-not-delivered-reason/create-not-delivered-reason.component'
import { NotDeliveredReasonComponent } from './not-delivered-reason.component'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { RouterModule } from '@angular/router'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { SharedModule } from 'src/app/shared/shared.module'
import { BreadcrumbsModule } from '@components/breadcrumbs/breadcrumbs.module'

@NgModule({
  declarations: [
    NotDeliveredReasonComponent,
    CreateNotDeliveredReasonComponent,
    UpdateNotDeliveredReasonComponent,
  ],
  imports: [
    HttpClientModule,
    CommonModule,
    BrowserAnimationsModule,
    SweetAlert2Module.forRoot(),
    RouterModule.forRoot(notDeliveredReasonRoutes, {
      scrollPositionRestoration: 'top',
    }),
    HttpClientModule,
    SharedModule,
    BreadcrumbsModule,
  ],
  exports: [
    NotDeliveredReasonComponent,
    CreateNotDeliveredReasonComponent,
    UpdateNotDeliveredReasonComponent,
  ],
})
export class NotDeliveredReasonModule {}
